// extracted by mini-css-extract-plugin
module.exports = {"container":"e_G1","placeholder":"e_H1","embed":"e_I1"};